export const commonPath = (index, keyname) => {
  return {
    COMMON: `[${index}][${keyname}]`,
  };
};

export const customColumnPath = (index, chIndex, chName) => {
  return {
    LABELCOLOURS_UPDATES: `[${index}].labelColoursOptions[${chIndex}][${chName}]`,
    STATUS_COLOURS: `[${index}].statusColoursOptions[${chIndex}][${chName}]`,
    STATUS_COLOURS_VALUE: `[${index}].statusColoursOptions[${chIndex}]`,
  };
};

export const calculationFormulaPath = (index, chIndex, keyname) => {
  return {
    FORMULA_OBJECT: `columns[${index}].formulaArr[${chIndex}][${keyname}]`,
    FORMULA_ARRAY: `columns[${index}].formulaArr`,
    FORMULA_STRING: `columns[${index}].formulaString`,
    READONLY_FORMULA_STRING: `columns[${index}].readOnlyFormulaString`,
  };
};

export const manualPath = (index, keyname, opInd) => {
  return {
    MANUAL_PATH: `columns[${index}][${keyname}]`,
    MANUAL_OPTIONS: `columns[${index}].options`,
    MANUAL_OPTIONS_OBJECT: `columns[${index}].options[${opInd}].name`,
    // MANUAL_NUMBER_OBJECT: `columns[${index}].numberValue`,
  };
};

export const sourcePath = (index, keyname) => {
  return {
    SOURCE_KEY_PATH: `[${index}].source[${keyname}]`,
  };
};

export const errorpath = (pindex, index, keyname) => {
  return {
    FORMULA_OBJECT_ERROR: `formulaArr[${pindex}][${index}][${keyname}]`,
    MANUAL_ERROR: `options[${pindex}][${index}].name`,
    SOURCE_ERROR: `source[${pindex}][${keyname}]`,
  };
};

export const universalPath = (pindex, pName, index, keyname) => {
  return {
    COMMON: `[${pindex}][${pName}][${index}][${keyname}]`,
  };
};
